import { render, staticRenderFns } from "./ReservationModal.vue?vue&type=template&id=1f19f082&scoped=true&lang=pug"
import script from "./ReservationModal.vue?vue&type=script&lang=ts"
export * from "./ReservationModal.vue?vue&type=script&lang=ts"
import style0 from "./ReservationModal.vue?vue&type=style&index=0&id=1f19f082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f19f082",
  null
  
)

export default component.exports